import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fb31f07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"padding":"8px"} }
const _hoisted_6 = {
  key: 0,
  class: "search-btn-radio"
}
const _hoisted_7 = { class: "pagination" }
const _hoisted_8 = {
  key: 0,
  class: "drawer-header-ar"
}
const _hoisted_9 = {
  key: 1,
  class: "drawer-header-all"
}
const _hoisted_10 = { class: "custom-header" }
const _hoisted_11 = {
  class: "info-title",
  placeholder: "amountPaid"
}
const _hoisted_12 = {
  class: "info-title",
  placeholder: "paymentMethod"
}
const _hoisted_13 = {
  class: "info-title",
  placeholder: "currency"
}
const _hoisted_14 = {
  class: "info-title",
  placeholder: "discountValue"
}
const _hoisted_15 = { class: "info-title" }
const _hoisted_16 = { class: "info-title" }
const _hoisted_17 = {
  class: "info-title",
  placeholder: "notes"
}

import {
  ref,
  reactive,
  onMounted,
  toRaw,
  computed,
  onBeforeUnmount,
} from "vue";
import type { Rule } from "ant-design-vue/es/form";
import Swal from "sweetalert2";
import {
  EyeOutlined,
  SearchOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons-vue";
import LbrxLoaderSpinner from "../../components/LbrxLoaderSpinner.vue";
import { notification } from "ant-design-vue";
import { storeService } from "@/_services";
import { paymentMethodsService } from "@/_services";
import { paymentService } from "@/_services";
import dayjs, { Dayjs } from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/fr";
import "dayjs/locale/ar";
import { I18nN, useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { currencyConfig } from "@/_helpers";


import {
  defineComponent,
 
} from "vue";
const __default__ = defineComponent({
  name: "indexStore",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

dayjs.extend(relativeTime);

const modalWidth = ref(720);
const scrollValue = ref(1500);
const popupWidth = ref(720);
const CollapsStatus = ref(false);
const customPagination = ref("10");
const { locale } = useI18n();
const router = useRouter();
const navigatePage = (link: string) => {
  router.push(link);
};

const searchInput = ref<HTMLInputElement | null>(null);

let PersistSearch = "";
const loading = ref(false);
const isDisabled = ref(false);
const { t } = useI18n();
const columns = [
  {
    title: t("Pos.PaymentMethod"),
    key: "payment_method",
    dataIndex: "payment_method",
    customFilterDropdown: true,
  },

  {
    title: t("Pos.PaidAmount"),
    key: "amount_paid",
    dataIndex: "amount_paid",
  },
  {
    title: t("Pos.paymentStatus"),
    key: "paidStatus",
    dataIndex: "paidStatus",
  },

  {
    title: t("Pos.CreatedAt"),
    key: "created_at",
    dataIndex: "created_at",
  },

  {
    title: t("Pos.Actions"),
    key: "actions",
    dataIndex: "actions",
  },
];
const lang = localStorage.getItem("Language") || "en";
const formatSaleDate = (dateString: string) => {
  return dayjs(dateString).locale(lang).fromNow();
  // return dayjs(dateString).locale(lang).fromNow();
};

//form
const formRef = ref();
const visible = ref<boolean>(false);

const reactiveData = reactive({
  data: [] as any[],
  action: "",
  totalPages: 0,
  searchText: "",
  searchedColumn: "",
  selectedType: "",
  totalPagesSearch: 0,
  beginSearch: false,
  fileChanged: false,
});

const reactiveData2 = reactive({
  data: [] as any[],
  action: "",
});

const form = reactive({
  id: "",
  name: "",
  description: "",
  address: "",
  phone: "",
  email: "",
  username: "",
  password: "",
  payment_method_id: "",
  config: "",
  status: "",
  accountNumber: "",
  active: "",
  isDisabled: false,
  currency_code: "",
  currency: "",
  amount_paid: "",
  payment_method: "",
  paidStatus: "",
  notes: "",
  firstname: "",
  lastname: "",
  discount: 0,
  discount_type: "",
  paid: "",
  customLastPage: 0,
});

const resetForm = () => {
  form.id = "";
  form.name = "";
  form.description = "";
  form.address = "";
  form.phone = "";
  form.email = "";
  form.username = "";
  form.payment_method_id = "";
  form.status = "";
  form.password = "";
  form.active = "";
  (form.paidStatus = ""), (form.isDisabled = false);
};

const perPage = ref<number>(10);
const currentPage = ref<number>(1);
const rules: Record<string, Rule[]> = {
  name: [{ required: true, message: "Please enter a name" }],
  contact_info: [{ required: true, message: "Please enter a contact info" }],
};

const value = ref<string>("1");

const formatDate = (dateString: any) => {
  return dayjs(dateString);
};

const textDirection = computed(() => {
  return locale.value === "ar" ? "rtl" : "ltr";
});

const formatDisplayDate = (dateString: string) => {
  return dayjs(dateString).format("DD-MM-YYYY HH:mm:ss");
};

const formatName = (dateString: any) => {
  if (dateString && dateString.method) {
    if (dateString.method.name) {
      return dateString.method.name;
    }
  }

  return "";
};

const formatcurrency_code = (dateString: any) => {
  if (dateString && dateString.currency) {
    if (dateString.currency.code) {
      return dateString.currency.code;
    }
  }
  return "";
};

const addCodeToAmount = (dateString: any) => {
  if (dateString && dateString.amount_paid) {
    const currenciesString = localStorage.getItem("currencies");
    if (currenciesString === null) {
      return;
    }
    const currencies = JSON.parse(currenciesString);
    const currencyCode = currencies.code;
    const decimalPrecision = 3;

    console.log("currencyCode", currencyCode);
    console.log("dateString", dateString.amount_paid);
    console.log("decimalPrecision", decimalPrecision);

    return currencyConfig.formatAmount(
      dateString.amount_paid,
      currencyCode,
      decimalPrecision
    );
  }
};

const selectedType = (value: any) => {
  console.log("selected radio option ", value.target.value);
  reactiveData.selectedType = value.target.value;
};

const handleSearch = (selectedKeys: any, confirm: any, dataIndex: any) => {
  customPagination.value = "10";
  currentPage.value = 1;
  confirm();
  reactiveData.searchText = selectedKeys[0];
  console.log("selected type is ", reactiveData.selectedType);
  reactiveData.searchedColumn = dataIndex;
  PersistSearch = reactiveData.selectedType;
  filter(PersistSearch);
};

const filter = (value: string) => {
  currentPage.value = 1;
  paymentService
    .filterWithPagination(
      value,
      currentPage.value.toString(),
      customPagination.value
    )
    .then((res) => {
      reactiveData.data = res.data;
      reactiveData.totalPagesSearch = res.meta.total;
      form.customLastPage = res.meta.last_page * 10;
      reactiveData.beginSearch = true;
    })
    .catch((error) => {
      console.log("error fetching", error);
    });
};

const handlePageChange = (newPage: any) => {
  currentPage.value = newPage;
  loading.value = true;

  //console.log('per page', perPage.value);
  //console.log('page', currentPage.value)
  if (reactiveData.selectedType == "") {
    paymentService
      .filterWithPaginationWithoutMethod(
        currentPage.value.toString(),
        customPagination.value
      )
      .then((response) => {
        //console.log('data', response.data)
        reactiveData.data = response.data;
        form.customLastPage = response.meta.last_page * 10;
      })
      .catch((error) => {
        //console.log("error api : get products", error);
      })
      .finally(() => {
        loading.value = false;
      });
  } else {
    paymentService
      .filterWithPagination(
        reactiveData.selectedType.toLocaleLowerCase(),
        currentPage.value.toString(),
        customPagination.value
      )
      .then((response) => {
        //console.log('data', response.data)
        reactiveData.data = response.data;
        form.customLastPage = response.meta.last_page * 10;
      })
      .catch((error) => {
        //console.log("error api : get products", error);
      })
      .finally(() => {
        loading.value = false;
      });
  }
};

const handleReset = (clearFilter: (arg: any) => void) => {
  currentPage.value = 1;
  clearFilter({ confirm: true });
  reactiveData.searchText = "";
  value.value ="";
  reactiveData.selectedType = "";
  customPagination.value = "10";
  getPaymentMethods();
};
const formatpayment_method = (dateString: any) => {
  if (dateString !== null) {
    if (dateString.payment_method.method.name) {
      return dateString.payment_method.method.name;
    }
  }
  return "";
};

const FormatEmptyNote = (dateString: any) => {
  if (dateString && dateString.notes) {
    return dateString.notes;
  } else {
    return "---";
  }
};

const formatID = (dateString: any) => {
  if (dateString && dateString.id) {
    if (dateString.id) {
      return "#" + " " + dateString.id;
    }
  }
  return "";
};

const formatpaidStatus = (dateString: any) => {
  if (dateString && dateString.sale) {
    if (dateString.sale.status) {
      return dateString.sale.status;
    }
  }
  return "";
};

const open = ref<boolean>(false);

const showAddDrawer = (state: boolean) => {
  updateModalWidth();
  open.value = state;
  reactiveData.action = "add";
  isDisabled.value = false;
  resetForm();
};

const afterOpenChange = (bool: boolean) => {
  //console.log('open', bool);
};

const showDrawer = (record: any) => {
  updateModalWidth();
  open.value = true;
  getPaymentMethodById(record.id);
  reactiveData.action = "update";
  //console.log(record.id)
  form.active = record.payment_method_id;
  isDisabled.value = true;
};

const openAdd = ref<boolean>(false);

const afterOpenAddChange = (bool: boolean) => {
  //console.log('open', bool);
};

const showSuccessNotification = (message: string) => {
  notification.success({
    message: message,
    duration: 3,
    top: "80px",
    style: {
      backgroundColor: "#bfffca8a",
      color: "white",
    },
  });
};

/*   const getStore = () => {
            storeService.getAll()
                .then((res) => {
                    reactiveData.data = res.data;
                })
                .catch((error: any) => {
                    console.error('Error fetching Stores:', error);
                });
        }*/

const getPaymentMethods = () => {
  loading.value = true;
  paymentService
    .getAll(currentPage.value, perPage.value)
    .then((res) => {
      reactiveData.data = res.data;
      reactiveData.totalPages = res.meta.total;
      form.customLastPage = res.meta.last_page * 10;
      //console.log(res.data)
    })
    .catch((error) => {
      //console.log("error api : get products", error);
    })
    .finally(() => {
      loading.value = false;
    });
};

const getPaymentNames = () => {
  paymentMethodsService
    .getNames()
    .then((res) => {
      reactiveData2.data = res.data;
      // console.log(res.data)
    })
    .catch((error: any) => {
      //console.error('Error fetching Stores:', error);
    });
};

const deletePaymentMethod = (id: string) => {
  paymentService
    .delete(id)
    .then((res) => {
      reactiveData.data = reactiveData.data.filter((e) => e.id !== id);
      showSuccessNotification("Payment method deleted successfully");
    })
    .catch((err) => {
      //console.log(err)
    })
    .finally(() => {
      // console.log('finish')
    });
};

const getPaymentMethodById = (id: string) => {
  paymentService
    .show(id)
    .then((res) => {
      // form.user_name = res.data.user.name;
      //form.sale_name = res.data.sale.name;
      //form.currency = res.data.currency.name;
      //form.payment_method = res.data.payment.name;

      //form.em   ail = res.data.email;

      form.amount_paid = res.data.sale.total + " " + res.data.currency.code;
      form.paid = res.data.sale.status;
      form.notes = res.data.notes;
      form.currency = res.data.currency.name;
      form.discount = res.data.sale.discount_value;
      form.discount_type = res.data.sale.discount_type;
      form.payment_method = res.data.payment_method.name;
    })
    .catch((error) => {
      //console.error('Error fetching categories:', error);
    });
};

const choosePerPage = () => {
  currentPage.value = 1;
  console.log(customPagination.value);
  // currentPage.value = newPage;
  loading.value = true;
  //console.log('per page', perPage.value);
  //console.log('page', currentPage.value)
  paymentService
    .filterWithPagination(
      reactiveData.selectedType,
      currentPage.value.toString(),
      customPagination.value
    )
    .then((response) => {
      //console.log('data', response.data)
      reactiveData.data = response.data;
      form.customLastPage = response.meta.last_page * 10;
      console.log("lastPage", form.customLastPage);
    })
    .catch((error) => {
      //console.log("error api : get products", error);
    })
    .finally(() => {
      loading.value = false;
    });
};
const addStore = () => {
  formRef.value.validate().then(() => {
    let payload = {
      name: form.name,
      description: form.description,
      address: form.address,
      phone: form.phone,
      email: form.email,
      username: form.username,
      password: form.password,
    };
    storeService
      .create(payload)
      .then((res) => {
        reactiveData.data.push(res.store);
      })
      .catch((err) => {
        //console.log(err)
      })
      .finally(() => {
        open.value = false;
      });
  });
};

const closePopup = () => {
  open.value = false;
};

const addPaymentMethod = () => {
  formRef.value.validate().then(() => {
    let payload = {
      payment_method_id: form.active,
      status: form.status,
      config: "null",
    };
    paymentMethodsService
      .create(payload)
      .then((res) => {
        reactiveData.data.push(res.data);
      })
      .catch((err) => {
        //console.log(err);
      })
      .finally(() => {
        open.value = false;
        location.reload(); // Refresh the page
      });
  });
};

const updatePaymentMethod = (id: any) => {
  let payload = {
    payment_method_id: 3,
    config: {},
    status: "active",
  };
  paymentMethodsService
    .update(id, payload)
    .then((res) => {
      reactiveData.data = reactiveData.data.map((el) =>
        el.id !== id ? el : res.data
      );
    })
    .catch((err) => {
      //console.log(err)
    })
    .finally(() => {
      // resetAdd();
      open.value = false;
      location.reload();
    });
};

const deleteStore = (id: string) => {
  storeService
    .delete(id)
    .then((res) => {
      reactiveData.data = reactiveData.data.filter((e) => e.id !== id);
      showSuccessNotification("Store deleted successfully");
    })
    .catch((err) => {
      //console.log(err)
    })
    .finally(() => {
      //console.log('finish')
    });
};

const showDeletePopup = (record: any) => {
  Swal.fire({
    title: "Delete Payment",
    text: "Are you sure you want to delte this payment",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#fc8019",
    confirmButtonText: "Delete",
    cancelButtonColor: "#d33",
    customClass: {
      popup: "swal2-popup",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      deletePaymentMethod(record.id);
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // console.log("cancel delete ");
    }
  });
};

onMounted(() => {
  updateSiderWidth;
  window.addEventListener("resize", updateSiderWidth);
  //getStore();
  getPaymentMethods();
  getPaymentNames();
  searchInput.value = document.querySelector(
    ".ant-table-filter-dropdown input"
  );
});

const updateModalWidth = () => {
  modalWidth.value = window.innerWidth <= 1200 ? window.innerWidth : 720;
};

const updateSiderWidth = () => {
  popupWidth.value = window.innerWidth >= 800 ? 729 : 250;
  CollapsStatus.value = window.innerWidth >= 1200 ? false : true;
  scrollValue.value = window.innerWidth >= 1200 ? 500 : 100;
};

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateSiderWidth);
});

// return {
//   modalWidth,
//   updateModalWidth,
//   scrollValue,
//   updateSiderWidth,
//   PersistSearch,
//   textDirection,
//   locale,
//   value,
//   rules,
//   handleReset,
//   handleSearch,
//   loading,
//   navigatePage,
//   formatID,
//   perPage,
//   currentPage,
//   handlePageChange,
//   addCodeToAmount,
//   t,
//   columns,
//   formRef,
//   form,
//   formatDisplayDate,
//   formatName,
//   reactiveData,
//   reactiveData2,
//   showAddDrawer,
//   showDrawer,
//   open,
//   formatDate,
//   addStore,
//   showDeletePopup,
//   visible,
//   addPaymentMethod,
//   updatePaymentMethod,
//   formatcurrency_code,
//   isDisabled,
//   closePopup,
//   formatpayment_method,
//   formatpaidStatus,
//   afterOpenChange,
//   selectedType,
//   choosePerPage,
//   customPagination,
//   FormatEmptyNote,
//   popupWidth,
// };

return (_ctx: any,_cache: any) => {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(LbrxLoaderSpinner, {
        "is-loaded": !loading.value
      }, null, 8, ["is-loaded"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_breadcrumb, {
        style: {"margin":"16px 0"},
        class: _normalizeClass({ 'is-rtl': textDirection.value === 'rtl' })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_breadcrumb_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (navigatePage('/'))),
            class: "breadcrumb-icon"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Pos.Home")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Pos.Payments")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_table, {
        class: "table-container",
        columns: columns,
        "data-source": reactiveData.data,
        pagination: false
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.key == 'actions')
            ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("Pos.View")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: ($event: any) => (showDrawer(record))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(EyeOutlined))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (column.key == 'payment_method')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (record.unit === 'Cash')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_unref(t)("Pos.Milligrams")), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (record.unit === 'Credit Card')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(t)("Pos.Pieces")), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (record.unit === 'Ticket')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_unref(t)("Pos.Milliliter")), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'id')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(formatID(record)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'currency_code')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode(_toDisplayString(formatcurrency_code(record)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'amount_paid')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(addCodeToAmount(record)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'payment_method')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                (record.payment_method != null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(formatpayment_method(record)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2, " --- "))
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'notes')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                _createTextVNode(_toDisplayString(FormatEmptyNote(record)), 1)
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'paidStatus')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                (record.sale?.is_paid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (record.sale.is_paid == '1')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 0,
                            bordered: false,
                            color: "success"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_unref(CheckCircleOutlined))
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_unref(t)("Pos.paid")), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (record.sale.is_paid == '0')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            bordered: false,
                            color: "error"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_unref(CheckCircleOutlined))
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_unref(t)("Pos.unpaid")), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (column.key == 'created_at')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                (record.sale != null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(formatSaleDate(record.sale.created_at)), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        customFilterDropdown: _withCtx(({ selectedKeys, confirm, clearFilters, column }) => [
          _createElementVNode("div", _hoisted_5, [
            (column.key === 'payment_method')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_a_radio_group, {
                    value: value.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
                    onChange: selectedType,
                    class: "search-radio-grp"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            value: "Cash",
                            class: "radio-item"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Cash")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            value: "Credit Card\t",
                            class: "radio-item"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Credit Card")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            value: "Ticket",
                            class: "radio-item"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Ticket")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, {
              type: "primary",
              size: "small",
              style: {"width":"90px","margin-right":"8px"},
              onClick: ($event: any) => (handleSearch(selectedKeys, confirm, column.dataIndex))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("Pos.Search")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              size: "small",
              style: {"width":"90px"},
              onClick: ($event: any) => (handleReset(clearFilters))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("Pos.Reset")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        customFilterIcon: _withCtx(({ filtered }) => [
          _createVNode(_unref(SearchOutlined), {
            style: _normalizeStyle({ color: filtered ? '#108ee9' : undefined })
          }, null, 8, ["style"])
        ]),
        _: 1
      }, 8, ["data-source"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_pagination, {
          class: "paginationArrows",
          current: currentPage.value,
          "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
          total: form.customLastPage,
          onChange: handlePageChange,
          "default-page-size": perPage.value,
          showSizeChanger: false
        }, null, 8, ["current", "total", "default-page-size"]),
        (form.customLastPage > 10)
          ? (_openBlock(), _createBlock(_component_a_select, {
              key: 0,
              class: "select-input",
              value: customPagination.value,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((customPagination).value = $event)),
              onChange: choosePerPage
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "10" }, {
                  default: _withCtx(() => [
                    _createTextVNode("10 / " + _toDisplayString(_unref(t)("Pos.page")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "20" }, {
                  default: _withCtx(() => [
                    _createTextVNode("20 / " + _toDisplayString(_unref(t)("Pos.page")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "50" }, {
                  default: _withCtx(() => [
                    _createTextVNode("50 / " + _toDisplayString(_unref(t)("Pos.page")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "100" }, {
                  default: _withCtx(() => [
                    _createTextVNode("100 / " + _toDisplayString(_unref(t)("Pos.page")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_a_drawer, {
        open: open.value,
        "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((open).value = $event)),
        class: "custom-class",
        "root-class-name": "root-class-name",
        "root-style": { color: 'blue' },
        style: {"color":"red"},
        title: null,
        placement: _unref(locale) === 'ar' ? 'left' : 'right',
        width: modalWidth.value,
        "body-style": { paddingBottom: '80px' },
        onAfterOpenChange: afterOpenChange
      }, {
        title: _withCtx(() => [
          (_unref(locale) === 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)("Pos.PaymentDetails")), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(locale) !== 'ar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)("Pos.PaymentDetails")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => []),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form,
            rules: rules,
            layout: "vertical",
            class: _normalizeClass({ 'is-rtl': textDirection.value === 'rtl' })
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("Pos.GeneralInformations")), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)("Pos.PaidAmount")) + " :", 1),
                        _createTextVNode(_toDisplayString(form.amount_paid), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)("Pos.PaymentMethod")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(form.payment_method), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)("Pos.currency")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(form.currency), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("Pos.discount")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(form.discount), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)("Pos.discountType")) + " : ", 1),
                        (form.discount_type === 'percentage')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_unref(t)("Pos.Percentage")), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (form.discount_type === 'cash')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_unref(t)("Pos.Cash")), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("Pos.Status")) + " :", 1),
                        (form.paid === 'paid')
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 0,
                              bordered: false,
                              color: "success"
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_unref(CheckCircleOutlined))
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_unref(t)("Pos.paid")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (form.paid === 'unpaid')
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 1,
                              bordered: false,
                              color: "error"
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_unref(CheckCircleOutlined))
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_unref(t)("Pos.unpaid")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("Pos.Notes")) + " :", 1),
                        _createTextVNode(" " + _toDisplayString(form.notes), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "class"])
        ]),
        _: 1
      }, 8, ["open", "placement", "width"])
    ])
  ], 64))
}
}

})